import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import UserPool from '../UserPool';
import axios from 'axios';

const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [config, setConfig] = useState(null);
    const [is3D, setIs3D] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    // Simplified - no automatic session restoration
    useEffect(() => {
        setIsLoading(false);
    }, []);

    const getToken = () => {
        return new Promise((resolve, reject) => {
          const current = UserPool.getCurrentUser();
    
          if (current) {
            current.getSession((err, session) => {
              if (err) return reject(err);
    
              if (session.isValid()) return resolve(session.getIdToken().getJwtToken());
    
              current.refreshSession(session.getRefreshToken(), (err, session) => {
                if (err) return reject(err);
    
                const idToken = session.getIdToken();
                setUser((prevUser) => ({ ...prevUser, idToken }));
                return resolve(idToken.getJwtToken());
              });
            });
          } else reject(new Error('No current user.'));
        });
    };

    const logout = () => {
        const current = UserPool.getCurrentUser();
        if (current) {
            current.signOut();
        }
        setUser(null);
        setConfig(null);
    };

    const value = useMemo(() => ({
        user,
        setUser,
        config,
        setConfig,
        getToken,
        logout,
        is3D,
        setIs3D,
        isLoading
    }), [user, config, is3D, isLoading]);
  
    return (
        <UserContext.Provider 
            value={value}
        >
        {children}
        </UserContext.Provider>
    );
    };

export const useUserContext = () => useContext(UserContext);
